import React from 'react'

import { TextLink, UiArrowRightIcon } from '@octane/spark'
import ClientApplication from 'api/application/interfaces/ClientApplication'
import Card from 'components/Card'
import useSafeCheck from 'hooks/useSafeCheck'
import ApplicationStatus from 'state/enums/ApplicationStatus'
import { formatPhoneNumber } from 'utils/formatPhoneNumber'

import {
    DetailContainer,
    DetailField,
    DetailInfo,
    DetailLabel,
    HeaderField,
    RuleLine,
    TextWrapper,
} from './DecisionResult.styled'
import DecisionResultComments from './DecisionResultComments'

export default function DecisionResultCollateralCard({
    clientApplication,
}: {
    readonly clientApplication: ClientApplication
}): JSX.Element {
    const getSafeCheckReportUrl = (applicationUUID: string) => {
        return `/#/safecheck/report/${applicationUUID}/`
    }

    const handleClickViewCreditReport = () => {
        window.location.href = getSafeCheckReportUrl(
            clientApplication?.uuid ?? '',
        )
    }

    const { canUseSafeCheck, hasSafeCheckReport } = useSafeCheck(
        clientApplication?.uuid ?? '',
    )

    const applicationIsJoint = clientApplication?.application_type === 'J'

    const renderApplicant = (isCoapplicant?: boolean) => {
        return (
            <DetailField style={{ paddingTop: '12px' }}>
                <DetailLabel
                    data-testid={isCoapplicant ? 'co-applicant' : 'applicant'}
                >
                    {isCoapplicant ? 'Co-Applicant' : 'Applicant'}
                </DetailLabel>
                <DetailInfo>
                    <TextWrapper>
                        {isCoapplicant
                            ? clientApplication.coapplicant_first_name
                            : clientApplication.first_name}{' '}
                        {isCoapplicant
                            ? clientApplication.coapplicant_last_name
                            : clientApplication.last_name}
                    </TextWrapper>
                    <TextWrapper>
                        {isCoapplicant
                            ? formatPhoneNumber(
                                  clientApplication.coapplicant_home_phone,
                              )
                            : formatPhoneNumber(clientApplication.home_phone)}
                    </TextWrapper>
                </DetailInfo>
                <DetailInfo>
                    {canUseSafeCheck &&
                        hasSafeCheckReport &&
                        clientApplication?.status ===
                            ApplicationStatus.DECLINE && (
                            <TextLink
                                onClick={handleClickViewCreditReport}
                                data-testid="view-credit-report-link"
                                variant="simple"
                            >
                                View Credit Report <UiArrowRightIcon />
                            </TextLink>
                        )}
                </DetailInfo>
            </DetailField>
        )
    }

    return (
        <Card style={{ padding: '20px' }}>
            <DetailContainer>
                <div>
                    <HeaderField>Customer Details</HeaderField>
                    <RuleLine />
                </div>
            </DetailContainer>
            {renderApplicant()}
            {applicationIsJoint && renderApplicant(true)}
            {clientApplication?.status !== ApplicationStatus.APPROVED && (
                <div style={{ marginTop: '10px' }}>
                    <DecisionResultComments
                        applicationId={clientApplication.id}
                        status={clientApplication?.status}
                    />
                </div>
            )}
        </Card>
    )
}
